export default __webpack_public_path__ + "static/media/Asset-65.953332d2.png";